import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=2b036891&scoped=true"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=2b036891&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b036891",
  null
  
)

export default component.exports